import { FC } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useModal } from 'store/modal';
import { useActiveClientContext } from 'store/active-client';
import { buildClientEntity, buildClientUrl } from 'utils/helpers/client';
import UpdateEntity from 'components/crud/UpdateEntity';
import { ISelectOptionProps } from 'components/form/types';
import { useQueryClient } from 'react-query';
import TemplateForm from './TemplateForm';
import { IDropdowns, IDocumentTemplate } from '../types';
import { formatDataOnSubmit } from '../dataFormatters';

interface IProps {
  templatesEntityName: string;
  template: IDocumentTemplate;
  categories: ISelectOptionProps[];
  templateDataOptions: IDropdowns;
}

const EditForm: FC<IProps> = ({ templatesEntityName, template, templateDataOptions, categories }: IProps) => {
  const { id } = useParams<{ id: string }>();
  const { showModal } = useModal();
  const history = useHistory();
  const { client } = useActiveClientContext();
  const queryClient = useQueryClient();

  const methods = useForm({
    defaultValues: {
      ...template,
      category_id: categories.find(cat => cat.value === template.category_id),
      can_be_created_by: templateDataOptions.can_be_created_by.find(opt => opt.value === template.can_be_created_by),
      storage_period: templateDataOptions.storage_period.find(opt => opt.value === template.storage_period),
      identifier: templateDataOptions.identifiers.find(opt => opt.value === template.identifier),
      employer_scenario: templateDataOptions.employer_scenario.find(opt => opt.value === template.employer_scenario),
      employee_scenario: templateDataOptions.employee_scenario?.find(opt => opt.value === template.employee_scenario),
    },
  });

  return (
    <UpdateEntity
      id={id}
      entity={templatesEntityName}
      methods={methods}
      onSuccess={(res: any) => {
        const { name, tokens = [] } = res.data;
        const nextPage =
          tokens.length > 0
            ? buildClientUrl(`/document-templates/manage-tokens/${id}`, client)
            : buildClientUrl('/document-templates', client);
        history.push({
          pathname: nextPage,
          state: {
            isEdit: true,
            templateName: name,
          },
        });

        if (!tokens.length)
          showModal({
            type: 'success',
            content: (
              <>
                Редактирахте шаблон за документ&nbsp;
                <span className="font-weight-bold">{name}</span>.
              </>
            ),
          });
      }}
      queryKey={[buildClientEntity(templatesEntityName, client), { id }]}
    >
      {(update: any) => (
        <TemplateForm
          methods={methods}
          handleSubmit={data => {
            queryClient.removeQueries([buildClientEntity('tokens', client), { template_id: id }]);
            return update(formatDataOnSubmit(data));
          }}
          btnLabel="Запази"
          templateDataOptions={templateDataOptions}
          canEdit={template.can_edit}
          categories={categories}
          isMultilingual={client?.is_multilingual}
        />
      )}
    </UpdateEntity>
  );
};

export default EditForm;
